export const teutonic = [
    {id:1,   name:"Maceman", wood:95, clay:75, iron:40, crop:40},
    {id:2,   name:"Spearman", wood:145, clay:70, iron:85, crop:40},
    {id:3,   name:"Axeman", wood:130, clay:120, iron:170, crop:70},
    {id:4,   name:"Scout", wood:160, clay:100, iron:50, crop:50},
    {id:5,   name:"Paladin", wood:370, clay:270, iron:290, crop:75},
    {id:6,   name:"Teutonic Knight", wood:450, clay:515, iron:480, crop:80 	},
    {id:7,   name:"Ram", wood:1000, clay:300, iron:350, crop:70},
    {id:8,   name:"Catapult", wood:900, clay:1200, iron:600, crop:60},
    {id:9,   name:"Chief", wood:35500, clay:26600, iron:25000, crop:27200},
    {id:10,  name:"Settler", wood:5800, clay:4400, iron:4600, crop:5200}
    ]